import "./App.css";
import Home from "./screen/Home";

function App() {
  return (
    <div className="">
      <Home />
    </div>
  );
}

export default App;
